import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NoticiaService } from '../../../providers/noticia.service';
import { PageEvent, Sort, MatTableDataSource, MatExpansionPanel, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { Noticia } from '../../../interfaces/noticia';
import { PermisoService } from '../../../providers/permiso.service';
import { VolverService } from '../../../providers/volver.service';

@Component({
  selector: 'app-ver-noticias',
  templateUrl: './ver-noticias.component.html',
  styleUrls: ['./ver-noticias.component.scss']
})
export class VerNoticiasComponent implements OnInit {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaNoticiasColumnas = ['fechaNoticia', 'fechaAlta', 'mostrarWeb', 'titulo', 'cuerpo'];
  noticiasDataSource = new MatTableDataSource();
  @ViewChild(MatSort) matSort: MatSort;
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtro: string = '';
  getNoticiasSuscripcion = new Subscription();
  noticiaCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las condicions
  tieneFiltrosOrdenPaginado = false;
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  filtros: any = {
    generico: ''
  };
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 0);
    }
  };

  constructor(
    private noticiaService: NoticiaService,
    private permisoService: PermisoService,
    private volverSv: VolverService
  ) {
    // pregunta si tiene permisos (retorna true o false)
    // si los permisos aún no estan cargados se queda preguntando hasta que esten cargados
    this.permisoService.tienePermiso('NOTICIA-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaNoticiasColumnas.push('acciones');
      }
    });
  }

  ngOnInit() {
    // set valores iniciales
    if (this.volverSv.usaronBotonVolver()) {
      this.restaurarPageState();
    } else {
      this.reiniciarPageState();
    }
  }

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_noticias_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this.limpiarPageState();
    this.restaurarPageState();
  }

  /**
   * olvidar el estado de la página
   */
  limpiarPageState() {
    // filtros
    localStorage.setItem('ver_noticias_filtros', null);
    // paginado
    localStorage.setItem('ver_noticias_paginado', null);
    // sort
    localStorage.setItem('ver_noticias_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  recordarPageState() {
    // filtros
    localStorage.setItem('ver_noticias_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_noticias_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_noticias_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_noticias_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_noticias_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_noticias_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_noticias_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fechaNoticia', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaNoticia' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getNoticiasSuscripcion && !this.getNoticiasSuscripcion.closed) {
        this.getNoticiasSuscripcion.unsubscribe();
      }

      this.recordarPageState();
      this.checkPageState();
      this.getNoticiasSuscripcion = this.noticiaService
        .getNoticias(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(this.filtrosExternos, this.filtros)
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.noticiaCount = respuesta.data.total;
              }

              var noticias: Noticia[] = []; // array de datos obtenidos
              if (respuesta.data.noticias) {
                respuesta.data.noticias.forEach(noticia => {
                  noticias.push(new Noticia(
                    noticia.id,
                    noticia.titulo,
                    noticia.cuerpo,
                    !!+noticia.mostrarWeb,
                    noticia.fecha,
                    noticia.fechaNoticia
                  ));
                });
              }

              this.noticiasDataSource.data = noticias;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
    if (this.getNoticiasSuscripcion && !this.getNoticiasSuscripcion.closed) {
      this.getNoticiasSuscripcion.unsubscribe();
    }
  }
}